// This file is imported from the theme, but it's easier to find if we colocate it with the component.
// These styles are applied to the button variants
// in addition to the base styles set in `theme.link.button`.
const buttonVariants = {
    default: {
        border: 1,
    },
    text: {
        border: 0,
        cursor: 'pointer',
        color: 'inherit',
    },
    icon: {
        backgroundColor: 'transparent',
        color: 'primary',
        paddingX: 2,
        // Make sure the text doesn't break into a new line by default.
        whiteSpace: 'nowrap',
        // Add a transparent border to make sure we have the same size as the secondary button.
        border: 1,
        borderColor: 'transparent',
        transition: 'color',
        ':hover': { color: 'secondary' },
        // Center icon vertically.
        display: 'inline-flex',
        alignItems: 'center',
        // Add a gap between icon and text.
        '> :first-of-type': { marginX: 1 },
    },
    primary: {
        backgroundColor: 'primary',
        color: 'onPrimary',
        paddingX: 3,
        // Add border to make sure we have the same size as the secondary button
        border: 1,
        borderColor: 'primary',
        transition: (theme) => { var _a, _b; return `${(_a = theme.transition) === null || _a === void 0 ? void 0 : _a.backgroundColor}, ${(_b = theme.transition) === null || _b === void 0 ? void 0 : _b.border}`; },
        ':hover': { backgroundColor: 'secondary', borderColor: 'secondary' },
    },
    secondary: {
        backgroundColor: 'onPrimary',
        color: 'primary',
        paddingX: 3,
        border: 1,
        borderColor: 'primary',
        transition: 'color',
        ':hover': { color: 'secondary', borderColor: 'secondary' },
    },
};
export default buttonVariants;
//# sourceMappingURL=buttonVariants.js.map